module.exports = __webpack_public_path__ + "static/media/processW.b494268b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Icons/processW.svg
// module id = 556
// module chunks = 0